export const wrongAudio = {
  url: 'https://victorina-tracks.s3.eu-central-1.amazonaws.com/Wrong.mp3',
};
